import { Lesson, curve, ellipse, type LessonLevel, type XY, K, R, Y, G, B, W } from './drawing-lesson-brushes';

const keywords = ['灯塔', '航标', '建筑', '海边', '海岛', '夜景', '透视', '光影'];
const paint = (d: Lesson, path: XY[], color: string, edge = color, width = 5) => {
  d.fill(path, color); d.stroke([...path, path[0]], edge, width, 'ink', 1, true);
};

function beginner(d: Lesson) {
  d.step('海岛托住灯塔', '先画扁扁的小岛和两侧波浪，灯塔会站在岛的中间。');
  d.shape(ellipse(500, 798, 290, 76), G, G);
  [857, 909].forEach((y, i) => d.line(curve([160 + i * 60, y], [[340, y - 21], [660, y + 21], [840 - i * 60, y]]), B, 13));
  d.step('上窄下宽的塔身', '两条斜边向上靠拢，红色横带沿着塔身的边缘收窄。');
  d.shape([[407, 342], [593, 342], [632, 784], [368, 784]], W);
  d.shape([[397, 458], [603, 458], [613, 568], [387, 568]], R, R);
  d.shape([[378, 675], [622, 675], [632, 784], [368, 784]], R, R);
  d.step('发亮的灯室', '塔顶放一个小房间，三角屋顶盖在黄色玻璃上面。');
  d.shape([[404, 252], [596, 252], [596, 342], [404, 342]], Y);
  d.shape([[374, 250], [500, 166], [626, 250]], R);
  d.line([[464, 260], [464, 336]], K, 7).line([[536, 260], [536, 336]], K, 7);
  d.line([[372, 349], [628, 349]], K, 14);
  d.step('小窗和灯光', '小窗排在中线，两束短线朝外照亮海面。');
  d.shape([[469, 605], [531, 605], [531, 646], [469, 646]], B);
  d.shape([[472, 730], [528, 730], [528, 784], [472, 784]], K);
  d.line([[349, 286], [262, 261]], Y, 19).line([[647, 286], [734, 261]], Y, 19);
  d.line(curve([704, 430], [[718, 412], [735, 412], [750, 430]], [[765, 412], [782, 412], [796, 430]]), K, 6);
}

function advanced(d: Lesson) {
  const c = d.theme.colors, t = d.theme;
  d.drawing.background = t.paper;
  d.step('海岸的远近', '远处海平线压低，岸线从左侧绕向右下角，给灯塔留出一块高地。');
  paint(d, [[35, 512], [963, 512], [963, 948], [35, 948]], c[3]);
  paint(d, curve([36, 655], [[215, 613], [363, 628], [488, 690]], [[573, 734], [730, 799], [964, 821]], [[964, 870], [964, 910], [964, 949]], [[630, 942], [235, 945], [36, 945]]), c[2]);
  d.stroke(curve([44, 658], [[210, 619], [359, 636], [487, 694]], [[598, 749], [773, 810], [954, 826]]), c[5], 24, 'crayon', 0.75, true);
  d.stroke([[57, 513], [950, 513]], c[4], 5, 'ink', 0.5, true);
  d.step('仰看的塔身', '塔身放在左侧，底部宽、顶部窄。右面的暗面从屋檐接到地面。');
  paint(d, [[273, 285], [380, 285], [424, 674], [224, 674]], c[5], c[0]);
  paint(d, [[352, 285], [380, 285], [424, 674], [372, 674]], t.shade);
  d.stroke(curve([379, 303], [[383, 417], [400, 558], [415, 656]]), c[4], 22, 'translucent', 0.17, true);
  paint(d, [[262, 391], [393, 391], [403, 482], [250, 482]], c[1]);
  paint(d, [[239, 580], [414, 580], [424, 674], [224, 674]], c[1]);
  d.stroke(curve([229, 680], [[290, 703], [359, 707], [449, 695]]), c[0], 22, 'translucent', 0.2, true);
  d.step('灯室与围栏', '灯室的侧面比正面暗。围栏先画上下横线，再连接竖杆。');
  paint(d, [[266, 210], [387, 210], [387, 285], [266, 285]], t.light, c[0]);
  paint(d, [[352, 210], [387, 210], [387, 285], [352, 285]], c[2]);
  paint(d, [[246, 210], [326, 158], [407, 210]], c[1], c[0]);
  d.stroke([[304, 216], [304, 279]], c[0], 5, 'ink');
  d.stroke([[349, 216], [349, 279]], c[0], 5, 'ink');
  d.stroke([[243, 288], [410, 288]], c[0], 6, 'ink');
  d.stroke([[243, 316], [410, 316]], c[0], 8, 'ink');
  [245, 279, 374, 408].forEach(x => d.stroke([[x, 288], [x, 316]], c[0], 5, 'ink'));
  d.step('门窗与岸边小路', '门贴住塔底，小路从门前弯向右下方。窗玻璃只留一条亮边。');
  paint(d, [[298, 611], [342, 611], [346, 672], [294, 672]], c[0]);
  paint(d, [[302, 509], [341, 509], [344, 554], [299, 554]], c[4]);
  d.stroke([[307, 518], [306, 543]], c[5], 4, 'ink');
  paint(d, curve([304, 683], [[353, 713], [512, 739], [686, 904]], [[733, 906], [757, 906], [785, 906]], [[593, 733], [400, 703], [341, 683]]), c[5]);
  d.stroke(curve([351, 703], [[469, 745], [596, 804], [702, 893]]), t.shade, 14, 'crayon', 0.3, true);
  d.step('海风与水面', '横向短浪越近越宽，两只海鸟引导视线看向远方。');
  [[529, 557, 708], [707, 604, 928], [523, 626, 640], [789, 714, 930]].forEach(([x, y, end]) => d.stroke(curve([x, y], [[x + 35, y - 8], [end - 35, y + 8], [end, y]]), c[5], 7, 'ink', 0.65));
  [[562, 306], [714, 370]].forEach(([x, y]) => d.stroke(curve([x, y], [[x + 14, y - 18], [x + 34, y - 18], [x + 48, y]], [[x + 62, y - 18], [x + 82, y - 18], [x + 96, y]]), c[0], 4.5, 'ink'));
  [143, 193, 836, 880].forEach((x, i) => d.stroke(curve([x, 841 + i % 2 * 39], [[x - 13, 818], [x - 20, 793], [x - 28, 774 + i % 2 * 30]]), c[4], 7, 'ink', 0.65));
}

function art(d: Lesson) {
  const c = d.theme.colors, t = d.theme;
  d.drawing.background = '#0B1026';
  d.step('夜海和月亮', '先分开天空与海面。月亮放左上角，把右半边留给海岬上的灯塔。');
  paint(d, [[26, 553], [973, 553], [973, 975], [26, 975]], c[4]);
  paint(d, ellipse(230, 206, 72, 72), c[5]);
  d.stroke(ellipse(230, 206, 65, 65, 3.7, 5.8), t.light, 7, 'glow', 0.32, true);
  d.stroke([[43, 554], [954, 554]], t.shade, 5, 'ink', 0.38, true);
  d.step('伸入海面的岩岬', '岩岬从右边伸出来，上缘平缓，下缘被海浪切成大小不一的石面。');
  paint(d, curve([495, 758], [[628, 707], [821, 701], [974, 714]], [[974, 798], [974, 884], [974, 974]], [[823, 943], [700, 912], [556, 868]], [[522, 836], [505, 799], [495, 758]]), c[0]);
  paint(d, [[503, 755], [658, 725], [832, 716], [974, 724], [974, 777], [799, 761], [620, 775], [531, 797]], c[1]);
  paint(d, [[534, 797], [620, 776], [587, 853], [554, 854]], t.shade);
  paint(d, [[650, 777], [734, 768], [700, 891], [627, 870]], c[4]);
  d.stroke([[732, 789], [716, 879]], c[3], 7, 'crayon', 0.4);
  d.step('白塔站在岩石上', '上窄下宽的塔身压住岩石，侧面留冷色阴影，底脚要真正落地。');
  paint(d, [[629, 328], [700, 328], [749, 729], [575, 744]], c[5]);
  paint(d, [[680, 329], [700, 328], [749, 729], [702, 734]], t.shade);
  d.stroke(curve([699, 358], [[711, 472], [724, 611], [739, 716]]), c[0], 16, 'translucent', 0.3, true);
  paint(d, [[616, 432], [713, 424], [725, 522], [602, 532]], c[1]);
  paint(d, [[589, 634], [737, 622], [749, 729], [575, 744]], c[1]);
  d.stroke([[621, 427], [630, 347]], c[5], 4, 'ink');
  d.step('亮灯的玻璃小屋', '黄色灯室与红屋顶相连，屋檐和围栏用深色细线稳住结构。');
  paint(d, [[621, 255], [707, 255], [707, 324], [621, 324]], c[2]);
  paint(d, [[607, 254], [660, 204], [721, 254]], c[1]);
  d.stroke([[645, 260], [645, 320]], c[0], 5, 'ink');
  d.stroke([[683, 260], [683, 320]], c[0], 5, 'ink');
  d.stroke([[607, 328], [723, 328]], c[0], 8, 'ink');
  d.stroke([[607, 348], [723, 348]], c[0], 7, 'ink');
  [608, 629, 701, 722].forEach(x => d.stroke([[x, 328], [x, 349]], c[0], 4, 'ink'));
  d.step('塔窗和迎光石面', '门与塔底相接。靠近灯塔的石面收一点暖光，远处仍保持冷暗。');
  paint(d, [[642, 674], [681, 671], [687, 734], [636, 738]], c[0]);
  paint(d, [[649, 558], [677, 556], [680, 593], [645, 596]], c[0]);
  d.stroke([[652, 563], [650, 584]], t.light, 3, 'ink');
  d.stroke(curve([565, 770], [[688, 746], [818, 743], [938, 753]]), t.accent, 16, 'crayon', 0.35, true);
  d.stroke(curve([592, 632], [[599, 593], [602, 560], [605, 543]]), t.light, 5, 'ink', 0.7);
  d.step('月色沿海面散开', '月亮下方的水纹由窄到宽。岩岬边的浪花沿石头转弯，不均匀铺满海面。');
  for (let i = 0; i < 9; i++) {
    const y = 592 + i * 35, x = 237 - i * 10;
    d.stroke(curve([x - 32 - i * 7, y], [[x - 4, y - 4], [x + 34, y + 4], [x + 60 + i * 7, y]]), i % 3 ? c[5] : t.light, 4 + i * 0.55, 'translucent', 0.13 + i * 0.008, true);
  }
  d.stroke(curve([476, 775], [[462, 829], [491, 866], [563, 887]], [[676, 932], [824, 960], [931, 970]]), c[3], 23, 'crayon', 0.55, true);
  d.stroke(curve([480, 810], [[479, 846], [508, 859], [545, 871]]), c[5], 6, 'ink', 0.65);
  d.stroke(curve([587, 908], [[642, 927], [686, 935], [746, 947]]), c[5], 5, 'ink', 0.52);
  d.step('海雾中的一束光', '从灯室向左扫出同方向的柔光，再把最亮的一点放回灯芯。');
  for (let i = 0; i < 7; i++) d.stroke(curve([637, 288], [[486, 287 + i * 3], [299, 295 + i * 11], [108, 314 + i * 17]]), t.light, 18, 'translucent', 0.08, true);
  d.stroke([[651, 283], [675, 283]], t.light, 13, 'glow', 0.85);
  d.stroke([[656, 282], [671, 282]], c[5], 6, 'pen');
}

function lighthouse(level: LessonLevel) {
  const d = new Lesson('lighthouse', level);
  [beginner, advanced, art][level](d);
  return d.done('lighthouse', '灯塔', ['上窄下宽 · 横带', '海岸远近 · 冷暖暗面', '月海守望 · 夜雾灯光'][level], keywords);
}

export const LIGHTHOUSE_EXAMPLES = [
  { id: 'lighthouse', title: '灯塔', skill: '海岸建筑 · 明暗光影', keywords, create: lighthouse },
];
